// chakra imports
import { Box, Flex, Stack } from "@chakra-ui/react";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import React from "react";

// FUNCTIONS

function SidebarContent(props) {
  const { routes, isCollapsed, onNavigate } = props;
  // SIDEBAR
  return (
    <Flex direction='column' height='100%' pt='25px' px={isCollapsed ? "8px" : "16px"} borderRadius='30px'>
      <Brand isCollapsed={isCollapsed} />
      <Stack direction='column' mb='auto' mt='8px'>
        <Box ps='4px' pe='0px'>
          <Links routes={routes} isCollapsed={isCollapsed} onNavigate={onNavigate} />
        </Box>
      </Stack>
    </Flex>
  );
}

export default SidebarContent;
